import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function IntroductionPage() {
  return (
    <ContentOverlay
      heading={
        <h3
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
            color: "black",
          }}
        >
          {" "}
          <b>Introduction</b>
        </h3>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              The freshwater ecosystems include lakes, ponds, streams, rivers,
              wetlands, springs, and groundwater. Wetlands (and lakes)
              constitute the most productive ecosystems, with a wide array of
              goods and services. These ecosystems serve as life support systems
              and habitats for a variety of organisms, including migratory
              birds, for food and shelter. They aid in bioremediation or
              removing contaminants and are aptly known as &lsquo;kidneys of the
              landscape&rsquo;. Major services include flood control, wastewater
              treatment, arresting sediment load, drinking water, protein
              production, and, more importantly, recharging of aquifers, apart
              from aiding as sinks and climate stabilizers. The wetlands provide
              a low-cost way to treat the community&rsquo;s wastewater while
              functioning as a wild fauna sanctuary with public access. Due to
              their rich biodiversity, these ecosystems are valuable for
              education and scientific endeavors.&nbsp;
            </p>
            <p>
              Wetlands (lakes) are crucial for sustaining the regional
              hydrological cycle and providing ecosystem services (provisioning,
              regulating, and cultural services) such as food, water provision,
              water purification, microclimate regulation, habitat provision,
              erosion control, flood mitigation, groundwater recharge, carbon
              sequestration, aesthetics, and recreation<sup>1</sup>. Complex
              natural processes like vegetation cover, climatic variability,
              hydrologic regime, agricultural run-off, anthropogenic activities
              like industrial and sewage discharge, and land use dynamics
              <sup>2-4</sup> govern the quality and quantity of water in water
              bodies.
            </p>
            <p>
              Physical, chemical, and biological factors influence water quality
              in freshwater bodies. The chemical integrity of waterbodies is
              altered with the discharge of untreated industrial effluents,
              agricultural run-off, soil erosion, farming in wetland areas,
              mining, and associated anthropogenic activities<sup>5</sup>. Many
              waterbodies have recently been severely contaminated due to the
              sustained inflow of untreated or partially treated domestic sewage
              and industrial effluents and rapid urbanization coupled with the
              increase in industrial expansion and population<sup>6-8</sup>. The
              influx of untreated wastewater has decreased dissolved oxygen
              (DO), affecting biota. Water quality degradation has recently
              raised a lot of concern due to its detrimental effects on social,
              economic, and health aspects, which have been a significant
              concern at the local, regional, and international levels. The
              River Ganga in India, which provides vital habitats to 350 fish
              species, is seriously threatened by rapid urban development and
              wastewater run-off from agricultural and industrial activities
              <sup>9</sup>. High nutrient load in Amirkalayeh wetland, Northern
              Iran, has raised the trophic level and hyper-eutrophication
              conditions<sup>10</sup>. Wastewater from industrial and
              agriculture sectors contributes wastewater laden with heavy
              metals, which causes toxicity, persistence, and biomagnification
              in biological organisms, which would lead to the contamination of
              the human food chain with severe health implications for society
              <sup>11,12</sup>, which necessitates assessing the cost of
              ecosystem degradation with the sustained discharge of untreated
              wastewater. Factors like light, water temperature, habitat
              conditions, climate, and substrate composition influence the
              composition and distribution of aquatic species. Wetlands serve as
              habitat for microalgae, zooplankton, fish, macrophytes, and water
              birds. The decline of biodiversity in aquatic ecosystems is due to
              habitat alteration, habitat loss, alteration in chemical integrity
              due to pollution, introduction of exotic species, overexploitation
              of aquatic organisms, etc.
            </p>
            <p>
              Geoinformatics, with the availability of spatial data acquired
              through space-borne sensors at regular intervals and advancements
              in the Geographic Information System (GIS), has been useful in
              assessing landscape dynamics, which provides vital insights for
              the prudent management of wetlands<sup>13-18</sup>.
            </p>
            <p>
              Bangalore city (Karnataka State, India) has been experiencing
              unprecedented urbanization and sprawl due to concentrated
              developmental activities in recent times, with an impetus on
              industrialization for economic development. This concentrated
              growth has increased population and consequent pressure on
              infrastructure and natural resources, ultimately giving rise to a
              plethora of serious challenges, such as climate change, enhanced
              greenhouse gas emissions, a lack of appropriate infrastructure,
              traffic congestion, and a lack of basic amenities (electricity,
              water, and sanitation) in many localities, etc. Temporal data
              analyses of five decades (1973 to 2023) reveal that there has been
              a 1055% increase in paved surfaces (built-up, etc.) with a decline
              in vegetation (88%) and water (79%). The urban heat island
              phenomenon is evident in a large number of localities with higher
              local temperatures. The city once enjoyed a salubrious climate
              (about 14 to16 &deg;C during peak summer&ndash;May month in the
              early 18<sup>th</sup> century), but now it has been experiencing
              higher temperatures (34 to 37&deg; C) with an altered microclimate
              and frequent flooding during rainy days. The study reveals the
              haphazard pattern of growth in Bangalore and its implication on
              local climate (an increase of ~2 to 2.5 &ordm;C during the last
              decade) and also on natural resources, necessitating appropriate
              strategies for the sustainable management of natural resources
              (water bodies, tree cover, etc.). The frequent flooding (since
              2000, even during normal rainfall) in Bangalore is a consequence
              of the increase in impervious areas with the high-density urban
              development in the catchment and the loss of wetlands and
              vegetation<sup>19</sup>.
            </p>
            <p>
              Urban ecosystems are the consequence of the intrinsic nature of
              humans as social beings live together. Unplanned urbanization and
              consequent urban sprawl have posed serious challenges to the
              decision-makers in the city planning and management process,
              involving a plethora of issues like inadequate infrastructure,
              traffic congestion, lack of basic amenities (electricity, water,
              and sanitation), loss of vegetation cover, decline in water bodies
              (quality and quantity), decline in groundwater table, recurring
              instances of floods, heat islands, enhanced greenhouse gas (GHG)
              footprint, etc. In this context, detailed field investigations
              were carried out in the existing lakes of Bangalore to understand
              the physical, chemical, and biological integrity through (a)
              assessment of the spatial dynamics of the lakes, (b) water quality
              encompassing physical and chemical aspects, (c) documentation of
              biodiversity (flora and fauna), and (d) assessment of threats.
              Based on these, the BLIS, or Bangalore Lake Information System,
              was designed for informed decision-making and prudent management.
              The present study bridges the information gap concerning lakes in
              Bangalore through the provision of information (lake-wise water
              quality, microalgae, zooplankton, fish, ecosystem services,
              threats- encroachments, etc.) based on the sustained ecological
              research on lakes of Bangalore over two decades.
            </p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default IntroductionPage;
